import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { connect } from 'react-redux'
import { useAppDispatch } from 'hooks/reduxHooks'
import { forgotPassword } from 'actions/AuthActions'
import BodyText from 'components/Luxkit/Typography/BodyText'
import PaneBody from 'components/Common/Pane/PaneBody'
import Clickable from 'components/Common/Clickable'
import { verticalChildSpacing } from 'components/utils/spacing'
import { fireInteractionEvent } from 'api/googleTagManager'
import { userForgotPassword } from 'analytics/eventDefinitions'

const Footer = styled(PaneBody)`
  margin: ${rem(24)} 0 0;
  ${verticalChildSpacing[24]}
`

const NoSpaceBodyText = styled(BodyText)`
  margin-top: ${rem(0)};
`

const StyledClickable = styled(Clickable)`
  display: inline;
  text-decoration: underline;
`

interface Props {
  error?: any;
  email?: string;
  open: boolean;
}

function ForgetPassword(props: Props) {
  const {
    email,
  } = props

  const dispatch = useAppDispatch()

  const onForgotPassword = () => {
    dispatch(forgotPassword(email))
    fireInteractionEvent(userForgotPassword())
  }

  return (
    <>
      <NoSpaceBodyText variant="large" weight="bold">{email}</NoSpaceBodyText>
      <Footer>
        <BodyText variant="medium">
          The reset link will expire in 24 hours. Please remember to check your spam folder
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          Don't see the email?{' '}
          <StyledClickable onClick={onForgotPassword}>Resend the email</StyledClickable>.
        </BodyText>
      </Footer>
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    error: state.auth.error,
  }
}

export default connect(mapStateToProps)(ForgetPassword)
